module.exports = __webpack_public_path__ + "media/frontend/svg/rightarrow-b9c030fdc0a946778eb95167bf8474a2.svg";